module.exports = __webpack_public_path__ + "static/media/Cafe_7.9c482989.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/cafe/Cafe_7.png
// module id = 1325
// module chunks = 3